import React from "react";
import { cn } from "@/lib/utils";
import { STATUS_STYLES, prettyStatus } from "@/lib/helpers";

export function StatusBadge({ status, className }) {
  const style = STATUS_STYLES[status] || "bg-slate-100 text-slate-700 border-slate-300";
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={cn(
        "inline-flex items-center border px-2.5 py-0.5 text-xs font-mono uppercase tracking-wider rounded-sm",
        style,
        className
      )}
    >
      {prettyStatus(status)}
    </span>
  );
}
